import React, { useContext } from "react";
import { node, string } from "prop-types";

import { MenuChangeContext, MenuStateContext } from "./MenuContext";
import * as S from "./styled";

const MultiLevelMenu = ({ children, title }) => {
  const menuState = useContext(MenuStateContext);
  const menuChange = useContext(MenuChangeContext);
  const onBack = menuChange?.onBack;
  const tree = menuState?.tree || [];
  const levelIndex = tree.length ? tree.indexOf(title) : -1;
  const prevLevel = levelIndex >= 1 ? levelIndex - 1 : -1;
  const prevLevelTitle = tree[prevLevel];

  return (
    <S.MenuWrapper isActive={levelIndex === tree.length - 1}>
      {prevLevelTitle !== undefined ? (
        <S.BackButton onClick={onBack || (() => {})}>
          {prevLevelTitle}
        </S.BackButton>
      ) : null}
      {children}
    </S.MenuWrapper>
  );
};

MultiLevelMenu.propTypes = {
  children: node.isRequired,
  title: string
};

MultiLevelMenu.defaultProps = {
  title: ""
};

export default MultiLevelMenu;
